<ngx-loading-bar [color]="'#FFF'" [height]="4"></ngx-loading-bar>
<app-navbar></app-navbar>
<div class="container-fluid main">
    <router-outlet></router-outlet>
</div>
<login></login>